import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import { Calendar, ArrowRight, User, ArrowUpRight } from 'lucide-react';
import api, { resolveImageUrl } from '../lib/api';
import { Button } from './ui/button';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/blog', { params: { limit: 3 } })
      .then((res) => setPosts(res.data))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  const fmtDate = (iso) => {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString('id-ID', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
    } catch {
      return iso;
    }
  };

  const stripHtml = (str = '') => {
    if (!str) return '';
    if (/<[a-z][\s\S]*>/i.test(str)) {
      const div = document.createElement('div');
      div.innerHTML = str;
      return div.textContent || div.innerText || '';
    }
    return str;
  };

  return (
    <section id="blog" className="relative py-24 lg:py-32 bg-[#080808]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div>
            <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
              <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
                Blog & Artikel
              </span>
            </div>
            <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight">
              Wawasan &{' '}
              <span className="gold-gradient-text">Tips Musisi</span>
            </h2>
          </div>
          <Button
            asChild
            variant="outline"
            className="self-start bg-transparent border border-white/15 hover:border-[#D4A94F] hover:bg-[#D4A94F]/5 text-white rounded-full btn-transition"
          >
            <Link to="/blog">
              Semua Artikel <ArrowUpRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 3 }).map((_, i) => (
              <div
                key={i}
                className="aspect-[4/5] rounded-3xl bg-[#111] animate-pulse border border-white/[0.04]"
              />
            ))}
          </div>
        ) : posts.length === 0 ? (
          <div className="text-center py-16 text-neutral-500">Belum ada artikel.</div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                className="group bg-[#0f0f0f] border border-white/[0.06] hover:border-[#D4A94F]/40 rounded-3xl overflow-hidden card-transition hover:-translate-y-1"
              >
                <div className="aspect-[16/10] bg-neutral-900 overflow-hidden relative">
                  {p.thumbnail && (
                    <img
                      src={resolveImageUrl(p.thumbnail)}
                      alt={p.title}
                      className="w-full h-full object-cover btn-transition group-hover:scale-105"
                      loading="lazy"
                    />
                  )}
                  <div className="absolute top-3 left-3">
                    <span className="text-[10px] tracking-widest uppercase font-bold text-black bg-[#D4A94F] px-2.5 py-1 rounded-full">
                      {p.category}
                    </span>
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center gap-4 text-xs text-neutral-500 mb-3">
                    <span className="flex items-center gap-1.5">
                      <Calendar className="w-3 h-3" />
                      {fmtDate(p.publish_date)}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <User className="w-3 h-3" />
                      {p.author}
                    </span>
                  </div>
                  <h3 className="text-white font-bold text-xl leading-tight mb-3 group-hover:text-[#E9C46A] btn-transition">
                    {p.title}
                  </h3>
                  <p className="text-neutral-400 text-sm leading-relaxed line-clamp-3">
                    {stripHtml(p.excerpt)}
                  </p>
                  <div className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-[#E9C46A]">
                    Baca Selengkapnya <ArrowRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Blog;
